import { useEffect, useRef } from "react";
import { fetchFacebookPages } from "@features/channels/fanpageSlice";
import { fetchZaloOAs } from "@features/channels/zaloSlice";
import { fetchTags } from "@features/tags/tagsSlice";
import { fetchAgents } from "@features/agents/agentsSlice";
import { CHANNELS } from "@common";
import { useChatStore } from "@stores/chatStore";
import type { AppDispatch } from "@stores/redux/store";

export const useFanpageBootstrap = (dispatch: AppDispatch) => {
  const hasFetchedRef = useRef(false);

  useEffect(() => {
    if (hasFetchedRef.current) return;
    hasFetchedRef.current = true;
    dispatch(fetchFacebookPages());
    dispatch(fetchTags({ offset: 0, limit: 20 }));
    dispatch(fetchAgents({ offset: 0, limit: 20 }));

    // Fetch Zalo OAs if persisted channel is ZALO
    const persistedState = useChatStore.getState();
    if (persistedState.selectedChannel === CHANNELS.ZALO) {
      dispatch(fetchZaloOAs());
    }
  }, [dispatch]);
};
